var _circle, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailCheckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 57,
    fill: "url(#paint0_linear_969_663)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 59.6665C33.64 59.6665 27.6666 65.6132 27.6666 72.9998C27.6666 80.3865 33.64 86.3332 41 86.3332C48.36 86.3332 54.3333 80.3598 54.3333 72.9998C54.3333 65.6398 48.3866 59.6665 41 59.6665ZM35.5599 67.5599H41C42.0133 67.5599 42.8133 68.3865 42.8133 69.3732C42.8133 70.3598 41.9866 71.1865 41 71.1865H35.5599C34.5466 71.1865 33.7466 70.3598 33.7466 69.3732C33.7466 68.3865 34.5466 67.5599 35.5599 67.5599ZM46.44 78.4398H35.5333C34.52 78.4398 33.7199 77.6132 33.7199 76.6265C33.7199 75.6398 34.5467 74.8132 35.5333 74.8132H46.44C47.4533 74.8132 48.2533 75.6398 48.2533 76.6265C48.2533 77.6132 47.4533 78.4398 46.44 78.4398Z",
    fill: "#206FFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M70.3334 33H43.6667C35.6667 33 30.3334 37 30.3334 46.3333V54.7067C30.3334 56.6533 32.3334 57.88 34.1201 57.1066C37.0534 55.8266 40.3867 55.3467 43.88 55.9067C50.8667 57.0533 56.5734 62.5733 57.9867 69.5067C58.3867 71.5333 58.44 73.5067 58.1734 75.4C57.96 76.9733 59.24 78.36 60.8134 78.36H70.3334C78.3334 78.36 83.6667 74.36 83.6667 65.0267V46.36C83.6667 37 78.3334 33 70.3334 33Z",
    fill: "#206FFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57 56.6534C54.76 56.6534 52.4933 55.9601 50.76 54.5468L42.4133 47.8801C41.56 47.1868 41.4 45.9334 42.0933 45.0801C42.7867 44.2267 44.04 44.0668 44.8933 44.7601L53.24 51.4268C55.2666 53.0534 58.7066 53.0534 60.7333 51.4268L69.08 44.7601C69.9333 44.0668 71.2133 44.2001 71.8799 45.0801C72.5733 45.9334 72.44 47.2134 71.56 47.8801L63.2133 54.5468C61.5066 55.9601 59.24 56.6534 57 56.6534Z",
    fill: "#206FFD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_969_663",
    x1: 57,
    y1: 0,
    x2: 57,
    y2: 114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#206FFD",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#206FFD",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailCheckIcon);
export default __webpack_public_path__ + "static/media/email-check-icon.ac8264fbf3a76f27bd9c3d78b8b171b2.svg";
export { ForwardRef as ReactComponent };